<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GxIPR/tc-custom/9781429941945.jpg?1731166600092" alt="This image is the cover for the book Future Crime"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Future Crime
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Future Crime</i> is a collection of six short stories and two novels by reknowned science fiction author Ben Bova!</b><br/><br/>From the Foreword: "Will crime always be with us? Yes, in the sense that every society sets down rules of conduct, and there will be members of every society who are not content to live within those rules. The important question is: How do we deal with such criminals? Execute them? Freeze them for future generations to consider? Or use our best powers to change them into useful, honest citizens? These stories examine some of those possibilities."<br/><br/><i>Future Crime</i> consists of five short stories by Ben Bova--"Vince's Dragon", "Out of Time", "Test in Orbit", "Stars, Won't You Hide Me?", and "Diamond Sam"--and one cowritten with Harlan Ellison, "Brillo". Also included are the short novels <i>Escape!</i> and <i>City of Darkness</i>.<br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ben Bova
      </h2>
      
      <p class="authorDescription body article"><P><B>Ben Bova</B> (1932-2020) was the author of more than a hundred works of science fact and fiction, including <I>Able One, Transhuman, Orion</I>, the Star Quest Trilogy, and the Grand Tour novels, including <I>Titan</I>, winner of John W. Campbell Memorial Award for best novel of the year. His many honors include the Isaac Asimov Memorial Award in 1996, the Lifetime Achievement Award of the Arthur C. Clarke Foundation in 2005, and the Robert A. Heinlein Award “for his outstanding body of work in the field of literature” in 2008.<br><br>Dr. Bova was President Emeritus of the National Space Society and a past president of Science Fiction Writers of America, and a former editor of <I>Analog</I> and former fiction editor of <I>Omni</I>. As an editor, he won science fiction’s Hugo Award six times. His writings predicted the Space Race of the 1960s, virtual reality, human cloning, the Strategic Defense Initiative (Star Wars), electronic book publishing, and much more.<br><br>In addition to his literary achievements, Bova worked for Project Vanguard, America’s first artificial satellite program, and for Avco Everett Research Laboratory, the company that created the heat shields for Apollo 11, helping the NASA astronauts land on the moon. He also taught science fiction at Harvard University and at New York City’s Hayden Planetarium and worked with such filmmakers as George Lucas and Gene Roddenberry.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5c9f14d9